var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColombiaFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.2143 14.3864C29.2143 16.2531 28.8466 18.1016 28.1323 19.8262C27.4179 21.5509 26.3709 23.1179 25.051 24.4379C23.731 25.7579 22.164 26.8049 20.4394 27.5193C18.7148 28.2337 16.8664 28.6014 14.9997 28.6014C13.133 28.6014 11.2846 28.2337 9.56005 27.5193C7.83546 26.8049 6.26845 25.7579 4.94851 24.4379C3.62856 23.1179 2.58153 21.5509 1.86718 19.8262C1.15283 18.1016 0.785156 16.2531 0.785156 14.3864L14.9997 14.3864H29.2143Z",
    fill: "#D21F35"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.785688 14.3861C0.785688 12.5194 1.15336 10.6709 1.86771 8.94629C2.58206 7.22165 3.6291 5.6546 4.94904 4.33462C6.26899 3.01464 7.83599 1.96757 9.56058 1.2532C11.2852 0.538833 13.1336 0.171153 15.0003 0.171153C16.867 0.171153 18.7154 0.538834 20.44 1.2532C22.1645 1.96757 23.7315 3.01464 25.0515 4.33462C26.3714 5.65461 27.4185 7.22165 28.1328 8.94629C28.8472 10.6709 29.2148 12.5194 29.2148 14.3861L15.0003 14.3861L0.785688 14.3861Z",
    fill: "#FECE28"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.18359 22.2906C1.66916 20.0307 0.78579 17.3122 0.785702 14.3876L29.2148 14.3876C29.2148 17.3122 28.3314 20.0307 26.817 22.2906L3.18359 22.2906Z",
    fill: "#164995"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColombiaFlag);
export default __webpack_public_path__ + "static/media/colombiaFlag.3da2dbd5ae6a00c0a5222b690dff55f5.svg";
export { ForwardRef as ReactComponent };